import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface CreateVariantDialogProps {
  open: boolean;
  onClose: () => void;
  currentVariantNeedsName: boolean;
  onCreate: (newVariantName: string, currentVariantName: string | null) => void;
}

export function CreateVariantDialog({
  open,
  onClose,
  currentVariantNeedsName,
  onCreate,
}: CreateVariantDialogProps) {
  const { t } = useTranslation();
  const [newVariantName, setNewVariantName] = useState('');
  const [currentVariantName, setCurrentVariantName] = useState('');

  const handleCreate = () => {
    onCreate(newVariantName.trim(), currentVariantNeedsName ? currentVariantName.trim() : null);
    setNewVariantName('');
    setCurrentVariantName('');
  };

  const isFormValid = !currentVariantNeedsName || currentVariantName.trim().length > 0;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t('editor.create_new_variant')}</DialogTitle>
      <DialogContent>
        {currentVariantNeedsName && (
          <>
            <DialogContentText sx={{ mb: 2 }}>
              {t('editor.name_current_variant')}
            </DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              label={t('editor.name_current_variant')}
              type="text"
              fullWidth
              variant="outlined"
              value={currentVariantName}
              onChange={(e) => setCurrentVariantName(e.target.value)}
              required
              sx={{ mb: 3 }}
            />
          </>
        )}
        
        <DialogContentText sx={{ mb: 2 }}>
          {t('editor.name_new_variant')}
        </DialogContentText>
        <TextField
          autoFocus={!currentVariantNeedsName}
          margin="dense"
          label={t('editor.name_new_variant')}
          type="text"
          fullWidth
          variant="outlined"
          value={newVariantName}
          onChange={(e) => setNewVariantName(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('common.cancel')}</Button>
        <Button 
          onClick={handleCreate} 
          variant="contained" 
          disabled={!isFormValid}
        >
          {t('editor.create_new_variant')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
